"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledBanner = void 0;
var _Banner = require("./Banner");
// TODO: in v9, move styled() from Banner.jsx to here
var StyledBanner = _Banner.Banner;
exports.StyledBanner = StyledBanner;